import { AppNavMenu, AppRoute } from 'src/pages';
// import { EncounterDetailsWrapper } from './details';
import { UserOutlined } from '@ant-design/icons';

export const encounterRoutes: AppRoute[] = [
  {
    path: '/encounters/:encounterId/:phase',
    element: <></>,
  },
  {
    path: '/encounters/:encounterId',
    element: <></>,
  },
];

export const encounterNavMenus: AppNavMenu[] = [
  {
    path: '/encounters',
    title: 'Encounters',
    icon: <UserOutlined />,
  },
];
